<template>
  <div class="addClassDialog">
    <div class="btnview">
      <el-button
        class="addclass"
        size="small"
        type="primary"
        plain
        @click="openDialog"
        >添加已试听班级</el-button
      >
    </div>
    <el-dialog
      title="选择已试听班级"
      :visible.sync="addClassDialogVisible"
      width="80%"
      top="10vh"
      append-to-body
    >
      <div class="dialog-body">
        <el-form
          size="small"
          :inline="true"
          class="form-style"
          ref="form"
          :model="form"
        >
          <el-form-item label="授课类型" prop="teaching_type">
            <el-select
              v-model="form.teaching_type"
              placeholder="请选择"
              style="width: 150px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="面授课" value="1"></el-option>
              <el-option label="直播课" value="2"></el-option>
              <el-option label="录播课" value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="科目">
            <el-select
              v-model="form.subject_id"
              placeholder="请选择"
              filterable
              style="width: 150px"
              @change="getCurriculumList"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) of subjectList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="课程体系" prop="curriculum_id">
            <el-select
              v-model="form.curriculum_id"
              placeholder="请选择"
              style="width: 150px"
              :disabled="!curriculum_list.length"
            >
              <el-option
                :label="item.title"
                :value="item.id"
                v-for="(item, index) of curriculum_list"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-input
              placeholder="请输入内容"
              v-model="form.search_value"
              class="input-with-select"
            >
              <el-select
                v-model="form.search_type"
                slot="prepend"
                style="width: 110px"
              >
                <el-option label="班级名称" value="1"></el-option>
                <el-option label="班级码" value="2"></el-option>
                <el-option label="教师名称" value="3"></el-option>
              </el-select>
            </el-input>
          </el-form-item>

          <el-form-item label="开课时间">
            <el-date-picker
              v-model="form.class_date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              placement="bottom-start"
            ></el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button @click="search" type="primary">搜索</el-button>
            <el-button @click="reset('form')">重置</el-button>
          </el-form-item>
        </el-form>

        <el-table
          size="small"
          ref="classTable"
          :data="tableData"
          tooltip-effect="dark"
          highlight-current-row
          @current-change="handleCurrentClass"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column
            fixed="left"
            width="150"
            label="班级名称"
            prop="name"
          ></el-table-column>
          <el-table-column label="科目" prop="subject_name"></el-table-column>
          <el-table-column
            width="150"
            label="体系名称"
            prop="curriculum_name"
          ></el-table-column>
          <el-table-column width="300" label="开课/结课">
            <template slot-scope="scope">
              {{ scope.row.start_date }} /
              {{ scope.row.end_date }}
            </template>
          </el-table-column>

          <el-table-column width="200" label="授课时段">
            <template slot-scope="scope">
              {{ scope.row.week_str }} /
              {{ scope.row.time_str }}
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            prop="lecturer_nickname"
            label="上课老师"
          ></el-table-column>

          <el-table-column
            width="150"
            prop="student_total_num"
            label="学员数"
          ></el-table-column>
        </el-table>

        <div style="margin-top: 30px; text-align: right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page_no"
            :page-size="20"
            layout="total,prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quit">取消</el-button>
        <el-button size="small" type="primary" @click="confirmTo"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getClassList,
  getCurriculumList,
  getUserTeacher,
  getStudentAllClassList,
} from '@/api/educational'
import { getUserSubjectList } from '@/api/user'
export default {
  name: 'addStudentClassDialog',
  props: {
    student_user_id: Number, //这样可以指定传入的类型，如果类型不对，会警告
  },
  data() {
    return {
      form: {
        search_type: '',
        search_value: '',
        subject_id: '',
        curriculum_id: '',
        teaching_type: '',
        course_state: '',
        page_no: '1',
        page_size: '20',
        class_date: [],
      },

      addClassDialogVisible: false,
      search_value: '',
      search_type: '1',
      curriculum_id: '',
      lecturer_id: '',
      subject_id: '',
      teacherList: [],
      curriculum_list: [],
      subjectList: [],
      teacher: '',
      tableData: [],
      total: 0,
      page_no: 1,
      chooseClassList: {},
    }
  },

  mounted() {
    console.log(this.student_user_id)
    this.getStudentAllClassList()
  },

  watch: {
    student_user_id() {
      console.log(this.student_user_id)
      this.getStudentAllClassList()
    },
  },

  methods: {
    //查询学生所有班级
    getStudentAllClassList() {
      getStudentAllClassList({
        student_user_id: this.student_user_id,
      }).then((res) => {
        console.log('学生的所有班级')
        console.log(res)
        this.tableData = res.stu_class_list
        this.total = res.stu_class_list.length
      })
    },

    getUserTeacher() {
      getUserTeacher().then((res) => {
        this.teacherList = res.user_list
        console.log('所有老师')
        console.log(res)
      })
    },
    openDialog() {
      this.getUserSubjectList()
      this.getUserTeacher()
      this.addClassDialogVisible = true
    },
    search() {
      console.log(this.form)
    },
    reset() {
      this.form = {
        search_type: '',
        search_value: '',
        subject_id: '',
        curriculum_id: '',
        teaching_type: '',
        course_state: '',
        page_no: '1',
        page_size: '20',
        class_date: [],
      }
    },
    handleCurrentChange(val) {
      console.log(val)
    },

    handleCurrentClass(val) {
      console.log(val)
      this.chooseClassList = val
    },

    // 获取学科
    getUserSubjectList() {
      getUserSubjectList().then((res) => {
        this.subjectList = res.base_platform.concat(res.mechanism_platform)
      })
    },
    // 获取课程体系
    getCurriculumList() {
      getCurriculumList({
        subject_id: this.subject_id,
        page_no: 1,
        page_size: 100,
      }).then((res) => {
        this.curriculum_list = res.curriculum_list
      })
    },
    // 获取班级列表
    getClassList() {
      getClassList({
        search_type: this.search_type,
        search_value: this.search_value,
        subject_id: this.subject_id,
        lecturer_id: this.lecturer_id,
        curriculum_id: this.curriculum_id,
        page_no: this.page_no,
      }).then((res) => {
        this.tableData = res.class_list
        this.total = res.total
      })
    },

    quit() {
      this.search_value = ''
      this.teacher = ''
      this.curriculum_id = ''
      this.subject_id = ''
      this.addClassDialogVisible = false
    },
    // 确认导入
    confirmTo() {
      console.log(this.chooseClassList)
      this.$emit('chooseAuditionClass', this.chooseClassList)
      this.quit()
    },
  },
}
</script>

<style scoped lang="scss">
.addClassDialog {
  .btnview {
    text-align: left;
    .addclass {
      margin-bottom: 20px;
    }
  }
}
</style>
